export default __webpack_public_path__ + "static/trustpilot-ed495c14af4f6228053fd079557f0b13.png";